import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import DragDropIcon from '../../../resources/icons/drag_drop.svg';
import { AutoCompleteOptionType } from '../../../components/molecules/autocompleteTypes';
import css from './BreakdownDimension.css';

const BreakdownDimension = ({ dimension, onRemove }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: dimension.value,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <div ref={setNodeRef} style={style} className={css.breakdownDimension}>
            <div className={css.dragHandle} {...attributes} {...listeners}>
                <DragDropIcon />
            </div>
            <span className={css.dimensionName}>
                <Translate id={dimension.label} />
            </span>
            <Icon
                name="x"
                size={IconSizes.XX_SMALL}
                variant={IconVariants.DARK}
                onClick={() => onRemove(dimension.value)}
            />
        </div>
    );
};

BreakdownDimension.propTypes = {
    dimension: AutoCompleteOptionType.isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default BreakdownDimension;
